module.exports = __webpack_public_path__ + "static/img/gzzShade4.7d4360a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzzShade4.png
// module id = 5NZ8
// module chunks = 2